var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"multi-stacked-bar-chart-container",staticStyle:{"height":"100%"}},[_c('svg',{ref:"chartSvg"})])}
var staticRenderFns = []

export { render, staticRenderFns }